"use strict";

(function () {
  var COOKIE_NAME = "aarp_visitor";
  var COOKIE_DAYS = 30;
  var DISCOUNT_CODE = "aarpexclusive";
  var ATTR_KEY = "AARP Member Number";

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function setAarpCookie() {
    if (typeof Cookies !== "undefined" && Cookies.set) {
      Cookies.set(COOKIE_NAME, "1", { expires: COOKIE_DAYS, path: "/" });
      return;
    }
    var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = COOKIE_NAME + "=1; expires=" + expires + "; path=/";
  }

  function hasAarpCookie() {
    if (typeof Cookies !== "undefined" && Cookies.get) {
      return Cookies.get(COOKIE_NAME) === "1";
    }
    return document.cookie.split("; ").some(function (part) {
      return part === COOKIE_NAME + "=1";
    });
  }

  function isAarpVisitor() {
    return getQueryParam("ref") === "aarp" || hasAarpCookie();
  }

  function captureRef() {
    if (getQueryParam("ref") === "aarp") {
      setAarpCookie();
    }
  }

  function showCartField() {
    var field = document.querySelector("[data-aarp-cart-field]");
    if (!field) return;
    if (!isAarpVisitor()) return;
    field.hidden = false;
    field.removeAttribute("hidden");
    field.classList.add("is-visible");
  }

  function setMessage(el, text, isError) {
    if (!el) return;
    el.textContent = text || "";
    el.hidden = !text;
    el.classList.toggle("is-error", !!isError);
  }

  function applyAarpDiscount(value, button, messageEl) {
    var trimmed = (value || "").trim();
    if (!trimmed) {
      setMessage(messageEl, "Please enter your AARP member number or email.", true);
      return;
    }

    setMessage(messageEl, "");
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    }

    var attributes = {};
    attributes[ATTR_KEY] = trimmed;

    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (!response.ok) throw response;
        window.location.href =
          "/discount/" + encodeURIComponent(DISCOUNT_CODE) + "?redirect=/cart";
      })
      .catch(function () {
        setMessage(messageEl, "Something went wrong. Please try again.", true);
        if (button) {
          button.disabled = false;
          button.removeAttribute("aria-busy");
        }
      });
  }

  function bindCartApply() {
    var form = document.querySelector("[data-aarp-cart-form]");
    if (!form) return;

    var input = form.querySelector("[data-aarp-member-input]");
    var button = form.querySelector("[data-aarp-apply]");
    var messageEl = form.querySelector("[data-aarp-message]");

    function handleApply(event) {
      if (event) event.preventDefault();
      applyAarpDiscount(input && input.value, button, messageEl);
    }

    if (button) {
      button.addEventListener("click", handleApply);
    }

    if (input) {
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          handleApply(event);
        }
      });
    }
  }

  function init() {
    captureRef();
    showCartField();
    bindCartApply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
